import { useFeatureFlag, User, ConfigCatProvider, PollingMode } from 'configcat-react';
import { useApplicationContext } from '../../contexts/ApplicationContext';

interface FeatureFlagIdentifier {
    channelId?: string;
    customerShortName?: string;
    countryCode?: string;
}

interface FeatureFlagValue {
    value: any;
    loading: boolean | undefined;
}

export const useSafeFeatureFlag = (
    name: string,
    defaultValue: any,
    identifier?: FeatureFlagIdentifier
): FeatureFlagValue => {
    const { user } = useApplicationContext();
    // Note: The "custom" field of the ConfigCat.User is in snake case to be consistent with other services
    const userIdentifier = new User(
        identifier?.channelId || 'no channel id',
        user?.email,
        identifier?.countryCode || null,
        { customer_short_name: identifier?.customerShortName }
    );
    try {
        return useFeatureFlag(name, defaultValue, userIdentifier);
    } catch (e) {
        return { value: defaultValue, loading: undefined };
    }
};

type FeatureFlagProviderProps = React.PropsWithChildren<{ sdkKey: string }>;

export const FeatureFlagProvider = ({ sdkKey, children }: FeatureFlagProviderProps) => {
    if (isValid(sdkKey)) {
        return (
            <ConfigCatProvider
                sdkKey={sdkKey}
                pollingMode={PollingMode.LazyLoad}
                options={{ cacheTimeToLiveSeconds: 60 * 5 }}
            >
                {children}
            </ConfigCatProvider>
        );
    } else {
        return <>{children}</>;
    }
};

const isValid = (sdkKey: string) => {
    return !(sdkKey === undefined || sdkKey.length == 0);
};
